export default __webpack_public_path__ + "static/banner-travel-now-with-a-personal-loan-or-credit-card-9cc29e93180533ebfce2650fa9842c67.jpg";